import React, { createContext, useContext, useState, useCallback } from "react";
import StrategyModal from "../components/StrategyModal";

const Ctx = createContext(null);

export function StrategyModalProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [source, setSource] = useState("home");
  const [defaults, setDefaults] = useState({});
  const openModal = useCallback((src = "home", opts = {}) => {
    setSource(src);
    setDefaults(opts || {});
    setOpen(true);
  }, []);
  const closeModal = useCallback(() => setOpen(false), []);
  return (
    <Ctx.Provider value={{ openModal, closeModal }}>
      {children}
      <StrategyModal open={open} onClose={closeModal} source={source} defaults={defaults} />
    </Ctx.Provider>
  );
}

export const useStrategyModal = () => {
  const v = useContext(Ctx);
  if (!v) throw new Error("useStrategyModal must be used within StrategyModalProvider");
  return v;
};
